import PageShell from '@/pages/shared/PageShell';
import Button from '@/components/base/Button';

export default function TemplateStatusReport() {
  return (
    <PageShell
      title="プロジェクト状況報告書テンプレート無料ダウンロード｜”おもいむすび”"
      description="プロジェクトの進捗状況を関係者に報告するための状況報告書テンプレートを無料ダウンロード。進捗サマリー、課題、リスク、マイルストーン状況、次期計画を網羅。"
      keywords="プロジェクト管理 状況報告,プロジェクト 進捗報告 テンプレート,プロジェクト ステータスレポート,プロジェクト管理 報告書"
      canonical="https://omoimusubi.asia/templates/project-status-report/"
      h1="プロジェクト状況報告書テンプレート（無料ダウンロード）"
      subtitle="プロジェクトの進捗状況をステークホルダーに報告するための状況報告書テンプレートです。週次・月次の定例報告にご活用ください。"
      relatedLinks={[
        { label: 'プロジェクト管理Excelテンプレート', path: '/templates/project-management-excel/' },
        { label: 'AI日報', path: '/features/ai-daily-report/' },
        { label: 'プロジェクト進捗管理ガイド', path: '/guides/project-progress-management/' },
        { label: 'プロジェクト日報ガイド', path: '/guides/project-daily-report/' },
      ]}
    >
      <div className="not-prose my-8 p-8 bg-primary-50 rounded-lg border border-primary-200/70 text-center">
        <div className="w-16 h-16 mx-auto bg-accent-100 rounded-full flex items-center justify-center mb-4">
          <i className="ri-file-chart-line text-accent-600 text-2xl"></i>
        </div>
        <h2 className="text-xl font-bold text-foreground-900 mb-2">プロジェクト状況報告書テンプレート</h2>
        <p className="text-sm text-foreground-600 mb-6">進捗サマリー、課題、リスク、マイルストーン状況、次期計画を網羅した報告書テンプレートです。</p>
        <a href="/templates/project-status-report-template.xlsx" download className="inline-flex items-center justify-center gap-2 whitespace-nowrap font-medium rounded-md bg-primary-500 text-background-50 hover:bg-primary-600 px-6 py-3 text-base transition-colors cursor-pointer"><i className="ri-download-2-line"></i>無料ダウンロード（Excel）</a><p className="text-xs text-foreground-500 mt-3">会員登録不要・無料でお使いいただけます。</p>
      </div>

      <section>
        <h2>テンプレートの構成</h2>
        <h3>1. 基本情報</h3>
        <ul>
          <li>プロジェクト名</li>
          <li>報告日</li>
          <li>報告者名</li>
          <li>報告期間（対象週・月）</li>
        </ul>

        <h3>2. 進捗サマリー</h3>
        <p>プロジェクト全体の進捗状況を「順調」「やや遅れ」「遅延」「完了」のいずれかで簡潔に示し、主要な進捗トピックを箇条書きで記載します。</p>

        <h3>3. タスク進捗詳細</h3>
        <p>報告期間内に完了したタスク、進行中のタスク、次期に着手予定のタスクをそれぞれ一覧で記載します。各タスクの進捗率と現在のステータスも併記します。</p>

        <h3>4. マイルストーン状況</h3>
        <p>設定したマイルストーンの達成状況を一覧表示します。「達成済」「予定通り」「遅延」「未着手」のいずれかで状況を示します。</p>

        <h3>5. 課題・リスク管理</h3>
        <p>現在発生している課題と、今後発生する可能性のあるリスクをそれぞれ一覧化します。各項目に「影響度（高・中・低）」「対応状況」「担当者」「対応期限」を記載します。</p>

        <h3>6. 次期計画</h3>
        <p>次回の報告期間に予定している主要な作業と目標を記載します。</p>

        <h3>7. 確認・承認欄</h3>
        <p>報告者の確認欄と、上位管理者の承認欄を設けています。</p>
      </section>

      <section>
        <h2>効果的な状況報告のポイント</h2>
        <ul>
          <li><strong>定期的に報告する</strong>：週次や月次など、決まったタイミングで報告することで、プロジェクトのリズムを作ります。</li>
          <li><strong>事実と予測を分ける</strong>：確定した事実と、今後起こりうるリスク予測は明確に区別して記載します。</li>
          <li><strong>課題は早めに共有する</strong>：問題が大きくなる前に報告し、早期の対策を促します。</li>
          <li><strong>数値で示す</strong>：進捗率や遅延日数など、できるだけ数値で状況を表現します。</li>
          <li><strong>読み手を意識する</strong>：経営層向けならサマリー中心、現場向けなら詳細なタスク情報を充実させるなど、報告先に合わせて調整します。</li>
        </ul>
      </section>

      <section>
        <h2>AI日報で報告業務を効率化</h2>
        <p>手動での状況報告書作成は手間がかかります。”おもいむすび”のAI日報機能を使えば、メンバーが日々の日報を入力するだけで、AIが進捗サマリーを自動生成します。タスクの進捗率やステータスも自動更新されるため、状況報告書の作成にかかる時間を大幅に削減できます。無料お試し（期限なし）で、ぜひ体験してください。</p>
      </section>
    </PageShell>
  );
}